<template>
  <div id="page-batches-list">
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <!-- tax mode - options -->
        <div class="tax_mode_options">
          <ul>
            <li class="my-3">
              <vs-radio v-model="taxModeValue" vs-name="tax_mode_option" :vs-value="taxMode.taxNotIncluded">Charge tax on top of the sale price</vs-radio>
            </li>
            <li class="my-3">
              <vs-radio v-model="taxModeValue" vs-name="tax_mode_option" :vs-value="taxMode.taxIncluded">Tax included in the sale price</vs-radio>
            </li>
          </ul>
        </div>

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner" alignment="center">
          <vs-tab label="Excise Tax" icon-pack="material-icons" icon="spa">
            <div class="tab-text">
              <tax-setting type="excise_tax" :taxMode="taxModeValue" />
            </div>
          </vs-tab>
          <vs-tab label="State Tax" icon-pack="material-icons" icon="assessment">
            <div class="tab-text">
              <tax-setting type="state_tax" :taxMode="taxModeValue" />
            </div>
          </vs-tab>
          <vs-tab label="County Tax" icon-pack="feather" icon="icon-layers">
            <div class="tab-text">
              <tax-setting type="county_tax" :taxMode="taxModeValue" />
            </div>
          </vs-tab>
          <vs-tab label="City Tax" icon-pack="feather" icon="icon-archive">
            <div class="tab-text">
              <tax-setting type="city_tax" :taxMode="taxModeValue" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import TaxSetting from '@/views/settings/components/TaxSetting.vue'
import { mapMutations, mapState } from 'vuex'
import { taxMode } from '@/utils/enums'

export default {
  name: 'TaxSetup',
  components: {
    TaxSetting
  },
  data: () => ({
    activeTab: 0,
    selected_tax_mode: null,
    taxMode
  }),

  computed: {
    ...mapState('setting', { loading: 'loading', taxs: 'taxes' }),
    taxModeValue: {
      get() {
        return this.selected_tax_mode
      },

      set(val) {
        this.selected_tax_mode = val
      }
    }
  },

  methods: {
    ...mapMutations('setting', { setTax: 'setTax' })
  },

  watch: {
    taxs() {
      this.selected_tax_mode = this.taxs.tax_mode
    }
  }
}
</script>
